module.exports = "https://static.wmbcdn.com/uniweb/images/559a51767543c6f585127ccbf682b610.png";